import { useEffect, useState } from 'react'
import { useFavoriteProducts } from '../../Providers/FavoriteProductsProvider'
import { GoStar } from "react-icons/go";
import { AiFillStar } from "react-icons/ai";
import { useAuth } from '../../Providers/AuthProvider';
import { useShop } from '../../Providers/ShopProvider';

const FavoriteStar = ({ isFavorite, index, size = 26 }) => {
    const { authState } = useAuth()
    const { setProducts } = useShop()
    const [isProductFavorite, setIsProductFavorite] = useState(false)
    const { addProductToFavorite, removeProductFromFavorite } = useFavoriteProducts()

    useEffect(() => {
        setIsProductFavorite(isFavorite)
    }, [isFavorite])

    const handleFavoriteIconClick = async () => {
        if (isProductFavorite) {
            if (await removeProductFromFavorite(index)) {
                setIsProductFavorite(false)
                handleUpdateProducts()
            }
        }
        else {
            if (await addProductToFavorite(index)) {
                setIsProductFavorite(true)
                handleUpdateProducts()
            }
        }
    }

    const handleUpdateProducts = () => {
        setProducts((prevProducts) =>
            prevProducts.map((product) =>
                product.index === index
                    ? { ...product, isFavorite: !product.isFavorite } : product))
    }

    if (!authState.user || !authState.user.userId) {
        return null
    }
    return (
        <>
            <div className='row' style={{ cursor: 'pointer' }}>
                {isProductFavorite ? (<AiFillStar size={size} onClick={handleFavoriteIconClick} color='var(--primary)' />) :
                    (<GoStar size={size} onClick={handleFavoriteIconClick} />)}
            </div>
        </>
    )
}

export default FavoriteStar